//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'spec-grid',
  props: {
    title: String,
    title2: String,
    title3: String
  }
};